import { API } from '../../api';
import { axiosInstance } from '../../axios';
import { IShareLinks } from '@/shared/api/share/getShareLinks/types';

interface Params {
  url: string;
  lang: string;
}

export const getShareLinks = async ({ url, lang }: Params) => {
  const result = await axiosInstance.get<{ result: IShareLinks }>(
    API.getShareLinks,
    { params: { url, lang } }
  );

  return result.data;
};
